import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: 50% 50%;
	margin-top: 30px;
`;

export const InputContainer = styled.div`
	width: 80%;
	display: grid;
	gap: 20px;
`;

export const DateContainer = styled.div`
	display: grid;
	grid-template-columns: 50% 50%;
	gap: 40px;
`;

export const SuperscriptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: end;
`;

export const Superscription = styled.div<{ color: string }>`
	width: 100%;
	font-size: 14px;
	font-weight: 500;
	color: #64778f;
	margin-bottom: 3px;

	&:before {
		content: '';
		width: 8px;
		height: 8px;
		border-radius: 50%;
		margin-right: 5px;
		display: inline-block;
		background-color: ${({ color }) => color};
		vertical-align: middle;
	}
`;

export const UploadContainer = styled.div`
	margin-top: 20px;
	label {
		height: 40px;
	}
`;

export const CalendarContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px 0;
`;
